import * as ko from 'knockout';
import page from 'page';

import { app } from '../app';
import { session } from '../session';
import { getExpirationDays } from '../models/tenant';
import * as tenantsApi from '../api/base_tenants';
import i18n from '../i18n';

let template = require('raw-loader!../../templates/cobranded_login.html').default;

interface LoginParams {
  motto: string;
  showFooter: boolean;
}

let loginParams: LoginParams = {
  motto: i18n.t('A faster, easier way to collect and analyse field trial data')(),
  showFooter: true,
};

class LoginScreen {
  allowSignUp = SERVER_INFO.ALLOW_SIGNUP;
  supportEmail = SERVER_INFO.SUPPORT_EMAIL;
  loading = ko.observable<boolean>(false);
  loggedIn = session.loggedIn;
  authorized = session.authorized;
  userEmail = ko.observable('');
  authorizedTenants = ko.pureComputed(() => {
    return this.getAuthorizedTenantsList();
  });
  firebaseTenantId = ko.observable<string>();
  tenantsByEmail = ko.observableArray<tenantsApi.TenantPublicData>();
  loadingTenantsByEmail = ko.observable(false);
  tenantsByEmailError = ko.observable('');
  loginEmail = ko.observable('').extend({ required: true, serverError: true });
  mobileOnlyTenants = session.mobileOnlyTenants;

  private subscription: KnockoutSubscription = null;
  public params: LoginParams;

  constructor() {
    this.params = loginParams;
    this.subscription = session.loggedIn.subscribe(this.onLoginStateChange.bind(this));
    this.onLoginStateChange(session.loggedIn());
  }

  async loadTenantsByEmail() {
    this.loadingTenantsByEmail(true);
    try {
      const tenants = await tenantsApi.tenantsByEmail(this.loginEmail());
      this.tenantsByEmail(tenants);
      if (tenants.length === 0) {
        this.tenantsByEmailError(i18n.t('Please check your email address.')());
      } else if (tenants.length === 1) {
        this.firebaseTenantId(tenants[0].firebase_id);
      }
    } finally {
      this.loadingTenantsByEmail(false);
    }
  }

  setSelectedTenant = (() => (tenant: tenantsApi.TenantPublicData) => {
    this.firebaseTenantId(tenant.firebase_id);
  })().bind(this);

  private getAuthorizedTenantsList() {
    let tenants = session.tenants();
    tenants.map((tenant) => {
      tenant.expirationTitle = tenant.is_expired
        ? i18n.t('Subscription of this organization is expired')()
        : '';
    });
    return tenants;
  }

  private onLoginStateChange(loggedIn: boolean) {
    if (!loggedIn) {
      return;
    }
    this.userEmail(session.getEmail());

    this.loading(true);
    session
      .getToken()
      .then((token) => tenantsApi.authorizations(token, true))
      .then(({ tenants, mobile_only_tenants }) => {
        this.loading(false);

        if (!session.loggedIn()) {
          // user logged out while we were loading list
          return;
        }

        this.userEmail(session.getEmail());
        session.tenants(tenants);
        session.mobileOnlyTenants(mobile_only_tenants);

        let slug = session.getLocationTenantSlug(location.pathname);
        if (slug) {
          var tenant: tenantsApi.TenantData = null;
          for (let aTenant of tenants) {
            if (aTenant.slug === slug) {
              tenant = aTenant;
              break;
            }
          }
          if (tenant) {
            this.openDirect(tenant);
          } else if (tenants.length > 0) {
            // user has selected a tenant he doesn't have access to
            // show him tenant list instead
            page('/');
          }
        } else {
          if (tenants.length === 1) {
            this.openDirect(tenants[0]);
          }
        }
      });
  }

  private openDirect(tenant: tenantsApi.TenantData) {
    if (location.pathname === '/') {
      (<any>page).replace(session.toTenantPath('/', tenant));
    } else {
      (<any>page).replace(location.pathname + location.search);
    }
  }

  dispose() {
    if (this.subscription) {
      this.subscription.dispose();
    }
  }
}

export let cobranded_login = {
  name: 'cobranded_login',
  viewModel: LoginScreen,
  template: template,
};

ko.components.register(cobranded_login.name, cobranded_login);

export function requireSfsaAuthorization(ctx: PageJS.Context, next: () => any) {
  if (session.authorized()) {
    let days = getExpirationDays();
    if (days !== null && days <= 0) {
      page.redirect(session.toTenantPath('/subscription/'));
    }
    next();
  } else {
    app.currentPage({ name: cobranded_login.name });
  }
}
